/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationstrustCommerceTrustCommerceIntegration from './IntegrationstrustCommerceTrustCommerceIntegration';

/**
 * The IntegrationsTrustCommerceBody model module.
 * @module model/IntegrationsTrustCommerceBody
 * @version v0.3
 */
export default class IntegrationsTrustCommerceBody {
  /**
   * Constructs a new <code>IntegrationsTrustCommerceBody</code>.
   * @alias module:model/IntegrationsTrustCommerceBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsTrustCommerceBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsTrustCommerceBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsTrustCommerceBody} The populated <code>IntegrationsTrustCommerceBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsTrustCommerceBody();
      if (data.hasOwnProperty('trust_commerce_integration'))
        obj.trustCommerceIntegration = IntegrationstrustCommerceTrustCommerceIntegration.constructFromObject(data['trust_commerce_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationstrustCommerceTrustCommerceIntegration} trustCommerceIntegration
 */
IntegrationsTrustCommerceBody.prototype.trustCommerceIntegration = undefined;

